import { Check } from '../../../../modules/design-system';
import type {
  IframePoolShippingPosition,
  PoolShippingService,
} from '../../../../modules/api';

export interface ServiceSectionProps {
  service: PoolShippingService | null;
  positions: IframePoolShippingPosition[];
}

/**
 * "Delivery Shipping Options" on the Show page — the protection option the
 * player chose. For game_platform the synthesized `service` IS positions[0],
 * so we render the chosen options ONCE (from positions) with no price here:
 * the real cost lives in the Payment section, and the per-position price is a
 * $0 placeholder for game_platform.
 */
export function ServiceSection({ service, positions }: ServiceSectionProps) {
  const options =
    positions.length > 0
      ? positions.map((p) => ({ id: p.id, name: p.name }))
      : service
        ? [{ id: service.id, name: service.name }]
        : [];

  if (options.length === 0) return null;

  return (
    <section>
      <h3
        className="text-[17px] font-bold tracking-[-0.3px]"
        style={{ color: 'var(--co-MyPacksItemCard-titleColor, #FFFFFF)' }}
      >
        Delivery Shipping Options
      </h3>

      <div
        className="mt-3 overflow-hidden rounded-[16px]"
        style={{
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        {options.map((o, idx) => (
          <div
            key={o.id}
            className="flex items-center gap-2 px-3 py-3 text-[14px] text-white"
            style={{
              borderTop: idx > 0 ? '1px solid rgba(255,255,255,0.08)' : undefined,
            }}
          >
            <Check size={16} strokeWidth={2} />
            <span>{o.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
